import loadable from '@loadable/component';

export const ReviewsForm = loadable(() => import('./'));
